<section class="splash">
  <div class="splash-inner">
    <h1>Signing you in…</h1>
    <p>Please wait while we complete authentication.</p>
    <div class="loader" aria-hidden="true"></div>
  </div>
</section>
